import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=a34355ca&"
import script from "./editArticle.vue?vue&type=script&lang=js&"
export * from "./editArticle.vue?vue&type=script&lang=js&"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=a34355ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports